
export enum UploadState
{
    NotUploaded = "NotUploaded",
    StartUploading = "StartUploading",
    Uploaded = "Uploaded",
    Error = "Error"
}

export enum OcrState
{
    NoOcr = "NoOcr",
    Started = "Started",
    Ready = "Ready",
    Error = "Error"
}
